<template>
  <div v-if="currentMany">
    <div class="self-assesment">
      <b-form-group
        horizontal
        breakpoint="lg"
        label-size="lg"
        label-class="break-label"
      >
        <b-button
          v-if="!editMode"
          variant="primary"
          style="
            margin-top: 15px;
            position: absolute;
            z-index: 999999999999;
            right: 27px;
          "
          @click="editMode = !editMode"
        >
          Editar
        </b-button>
        <b-button
          v-if="editMode && !saveOnClick"
          variant="primary"
          style="
            margin-top: 15px;
            position: absolute;
            z-index: 999999999999;
            right: 27px;
          "
          @click="save()"
        >
          Guardar
        </b-button>
        <div v-for="(data, index) in arrayWithTitles" :key="index">
          <div v-if="data.list && data.list.length">
            <div
              style="display: inline-block"
              :class="{ 'caret-down': data.open, 'caret-right': !data.open }"
              @click="open(data)"
            />
            <div style="display: inline-block">
              {{ data[currentMany.name] }}
            </div>
            <div
              style="
                display: inline-block;
                cursor: pointer;
                color: gray;
                font-size: 11px;
              "
              @click="selectAllChildren(data)"
            >
              Select All
            </div>
          </div>
          <div v-if="!data.list || !data.list.length">
            <b-checkbox
              v-model="data.selected"
              :disabled="!editMode"
              @change="change(data)"
            >
              <div v-html="formatDisplayName(data,currentMany. fieldsToDisplay)"></div>
            </b-checkbox>
          </div>
          <div
            v-if="data.open && data.list && data.list.length"
            style="padding-left: 15px"
          >
            <b-checkbox
              v-for="(data2, index) in data.list"
              :key="index"
              v-model="data2.selected"
              :disabled="!editMode"
              @change="changeChild(data2)"
            >
              {{ data2[currentMany.name] }}
            </b-checkbox>
          </div>
        </div>
      </b-form-group>

      <!--        <b-col cols="6" >
                <div >
                  <h2>{{leftHeader}}</h2 >
                  <draggable class="list-group"  :list="grantedArray" group="people" @change="log">
                    <div
                      class="list-group-item"
                      v-for="(element, index) in grantedArray"
                      :key="element.name"
                    >
                      {{ element.name }}
                    </div>
                  </draggable>
                </div>
              </b-col>
              <b-col cols="6">
                <div>
                  <h2>{{rightHeader}}</h2>
                  <draggable class="list-group" :list="revokedArray" group="people">
                    <div
                      class="list-group-item"
                      v-for="(element, index) in revokedArray"
                      :key="element.name"
                    >
                      {{ element.name }}
                    </div>
                  </draggable>
                </div>
              </b-col>-->
    </div>
    <!--<div v-for="(md,indexMany) in manyData">
      <b-form-checkbox
        v-model="md.status"
        @change="addMany(md[currentMany.id],md.status)"
      >
        {{md[currentMany.name]}}
      </b-form-checkbox>
    </div>-->
    <b-modal
      id="modalInfo"
      v-model="showModal"
      modal-class="modalInfo"
      :title="$t('Guardado satisfactoriamente')"
    >
      <p>{{ $t("Guardado satisfactoriamente") }}</p>
      <div slot="modal-footer" class="w-100">
        <b-btn variant="primary" @click="showModal = false">
          {{ $t("label_selfAssessment_submitReview_modal_confirmation") }}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable vue/no-mutating-props */
import { GetTableDataByName } from "./tablesConfiguration";
import { FieldType } from "../commons";
import { axiosCall } from "../axiosCall";

export default {
  name: "IndicaCheckboxHierarchy",
  components: {},
  props: {
    tableName: {
      type: String,
      default: null,
    },
    leftHeader: {
      type: String,
      default: null,
    },
    rightHeader: {
      type: String,
      default: null,
    },
    refresh: {
      type: Number,
      default: 0,
    },
    currentId: {
      type: String,
      default: null,
    },
    manyTableName: {
      type: String,
      default: null,
    },
    nameField: {
      type: String,
      default: "name",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    saveOnClick: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      retrievedData: null,
      perPage: 5,
      currentPage: 1,
      rows: 1,
      tableData: null,
      showModal: false,
      manyData: null,
      currentMany: null,
      FieldType: FieldType,
      revokedArray: [],
      grantedArray: [],
      allDataArray: [],
      arrayWithTitles: [],
    };
  },
  watch: {
    currentId: async function () {
      await this.refreshData();
    },
    refresh: async function () {
      await this.refreshData();
    },
  },
  created: async function () {
    await this.refreshData();
  },
  methods: {
    formatDisplayName(data, fieldsToDisplay){
      return [...fieldsToDisplay].reverse().reduce((acc,current)=>(`${this.$t(data[current.field])} ${current.separator || ''} ${acc}`),'')
    },
    change: async function (data) {
      if (!data.list) {
        await this.changeChild(data);
      }
    },
    open: function (data) {
      data.open = !data.open;
      this.$forceUpdate();
    },
    selectAllChildren: function (data) {
      data.list.map((child) => {
        this.changeChild(child, true);
        child.selected = true;
      });
      this.$forceUpdate();
    },
    changeChild: async function (data, valueToForce) {
      if (this.saveOnClick) {
        await this.addMany(
          data[this.currentMany.id],
          valueToForce || !data.selected
        );
      } else {
        if (data.list) {
          data.list.map((data2) => {
            data2.selected = true;
          });
        }
      }
      this.retrieveData();
    },
    async save() {
      await this.arrayWithTitles.map(async (data) => {
        if (data.list) {
          await data.list.map(async (data2) => {
            await this.addMany(data2[this.currentMany.id], data2.selected);
          });
        } else {
          await this.addMany(data[this.currentMany.id], data.selected);
        }
      });
      this.editMode = false;
      this.showModal = true;
    },
    retrieveData() {
      this.$emit("retrieveData", this.grantedArray);
    },
    refreshData: async function () {
      this.getTableData();
      await this.getMany(this.manyTableName);
      if (this.currentId) {
        await this.getManyInserted();
      } else {
        this.revokedArray = this.allDataArray;
      }
      this.$forceUpdate();
    },
    getTableData() {
      if (this.tableName) {
        this.tableData = GetTableDataByName(this.tableName);
        const currMany = this.tableData.ManyToManyRelationships.filter(
          (many) => many.tableName === this.manyTableName
        );
        if (currMany.length > 0) {
          this.currentMany = currMany[0];
        }
      }
    },
    setEdit: function (id) {
      this.$emit("edit", id);
    },
    getManyInserted: async function () {
      const where = {};
      where["where"] = {};
      where["where"][this.currentMany.localField] = this.currentId;
      await axiosCall({
        url:
          `${this.currentMany.breakingTableName}?filter=` +
          JSON.stringify(where),
        method: "get",
      }).then((s) => {
        const granted = s.data.map((dat) => dat[this.currentMany.foreignField]);
        const arrayWithTitles = {};
        this.allDataArray.map((data) => {
          let manyFromDb = s.data.find(
            (many) =>
              many[this.currentMany.foreignField] === data[this.currentMany.id]
          );
          data.selected = granted.includes(data[this.currentMany.id]);
          if (manyFromDb) {
            data.relationshipId = manyFromDb.id;
          }
          if (
            this.currentMany.splitCharacter &&
            data[this.currentMany.name] &&
            data[this.currentMany.name].includes(
              this.currentMany.splitCharacter
            )
          ) {
            const split = data[this.currentMany.name].split(
              this.currentMany.splitCharacter
            );
            if (typeof arrayWithTitles[split[0]] === "undefined") {
              arrayWithTitles[split[0]] = {
                name: split[0],
                list: [],
              };
            }
            if (data.selected) {
              arrayWithTitles[split[0]].open = true;
            }
            const dat = { ...data };
            dat.name = dat[this.currentMany.name]
              .replace(split[0], "")
              .replace(".", "");
            arrayWithTitles[split[0]].list.push(dat);
          } else {
            if (
              typeof arrayWithTitles[data[this.currentMany.name]] ===
              "undefined"
            ) {
              arrayWithTitles[data[this.currentMany.name]] = {
                ...data,
              };
            }
          }
        });
        this.arrayWithTitles = Object.values(arrayWithTitles);

        //    this.grantedArray = this.allDataArray.filter(dat => granted.includes(dat[this.currentMany.id]))
        //          this.revokedArray = this.allDataArray.filter(dat => !granted.includes(dat[this.currentMany.id]))

        /* this.grantedArray.map(manyD => {
          const element = s.data.filter(dd => dd[this.currentMany.foreignField] === manyD[this.currentMany.id])
          if (element.length > 0) {
            // manyD.status = true
            manyD.relationshipId = element[0].id
          }
        })*/
      });
      this.retrieveData();
    },
    addMany: async function (manyId, checked) {
      if (checked === false) {
        const many = this.manyData.find(
          (many) => many[this.currentMany.id] === manyId
        );
        if (many && many.relationshipId) {
          await axiosCall({
            url: `${this.currentMany.breakingTableName}/${many.relationshipId}`,
            method: "delete",
          }).then(() => {
            this.manyData
              .filter((many) => many[this.currentMany.id] === manyId)
              .map((many) => {
                many.status = false;
              });
          });
        }
      } else {
        let many = this.manyData.find(
          (many) => many[this.currentMany.id] === manyId
        );
        if (!many || !many.relationshipId) {
          const data = {};
          data[this.currentMany.localField] = this.currentId;
          data[this.currentMany.foreignField] = manyId;
          await axiosCall({
            url: this.currentMany.breakingTableName,
            method: "put",
            data: data,
          }).then((s) => {
            this.manyData
              .filter((many) => many[this.currentMany.id] === manyId)
              .map((many) => {
                many.relationshipId = s.data.id;
              });
          });
        }
      }
      this.retrieveData();
    },
    lowerFirstLetter: function (string) {
      return string.charAt(0).toLowerCase() + string.slice(1);
    },
    getMany: async function (table) {
      await axiosCall({ url: table, method: "get" }).then((response) => {
        this.manyData = response.data;
        this.allDataArray = response.data;
      });
    },
  },
};
</script>
<style lang="scss">
.list-group {
  min-height: 300px;
  border: 1px dashed gray;
  max-height: 500px;
  overflow-y: auto;

  .list-group-item {
    word-break: break-all;
  }
}

.caret-down:before {
  content: "\25bc";
  cursor: pointer;
}

.caret-right:before {
  cursor: pointer;
  content: "\25ba";
}
</style>
